var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 412,
    height: 260,
    viewBox: "0 0 412 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.154
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 53,
    r: 7,
    stroke: "#FFF573"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF5794",
    points: "95.768 75.788 97.278 92.868 86.278 88.248"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#62F8D2",
    points: "358.925 46.699 371.545 53.767 356.437 65.815"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#62F8D2",
    points: "102 163 114.947 165.582 105.324 177.873"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#444242",
    transform: "translate(28 129)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 33.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 33.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 41.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 25.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 17.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 9.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 9.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 1.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 49.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 49.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 57.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 41.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 33.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 33.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 41.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 25.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 25.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 17.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 64.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 64.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 72.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 56.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 48.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 48.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 56.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 40.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.5,
    cy: 40.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 32.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 71.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 79.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.5,
    cy: 55.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 63.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.5,
    cy: 47.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 87.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.5,
    cy: 87.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 95.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 79.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.5,
    cy: 71.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 71.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.5,
    cy: 79.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.5,
    cy: 63.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 63.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 55.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.5,
    cy: 102.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 102.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.5,
    cy: 110.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.5,
    cy: 94.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 86.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.5,
    cy: 86.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 94.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 78.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 78.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.5,
    cy: 70.5,
    r: 1.5
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#59167D",
    points: "354.483 179 366.071 187.965 351 196.931"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6E358E",
    strokeLinecap: "square",
    d: "M339.5,80.5 L356.5,80.5 M348,72 L348,89"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FEF033",
    strokeLinecap: "square",
    d: "M238.5,176 L255.5,176 M247,167.5 L247,184.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPattern);
export default __webpack_public_path__ + "static/media/bg_pattern.94d8a672ddf72778abfeb6672ccc6ade.svg";
export { ForwardRef as ReactComponent };